<template>
    <div class="main-body">
        <div class="header">
            工单管理
        </div>
        <div class="out">

            <div class="search2">

                <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">订单操作</el-button>
                <el-button size="mini" type="success" plain @click.native="elderlyAdd">老人注册</el-button>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 0px;"></div>

            <div>
                <el-row>
                    <el-col :span="7">
                        <el-card class="box-card"  shadow="never" :style="{height:(th+50)+'px'}" :body-style='{padding:"10px"}'>
                            <el-tabs type="card" :style="{height:(th-12)+'px'}">
                                <el-tab-pane label="全部">
                                    <div class="paneContent" :style="{height:(th-82)+'px'}">
                                        <div v-for="(item,i) in callRecordData" :key="i" @click="activeIndex=i">
                                            <el-row type="flex" :class="{'row-bg':true,xz:activeIndex==i,'red':item.recStatus==-1||item.recStatus==-2,'blue':item.recStatus==1}" justify="space-around">
                                                <el-col :span="18">
                                                    <span :class="{'number':true,}">{{seatsPhone==item.calledPhone?item.callingPhone:item.calledPhone}}<span>{{item.recStatus==-1||item.recStatus==-2 ?'（未接）':'（已接）'}}</span></span><br>
                                                    <span class="address">{{item.address}}</span>
                                                </el-col>
                                                <el-col :span="6">
                                                    <div :class="{'iconPhone':true}">
                                                        <i class="el-icon-phone"></i>
                                                        <span>{{ seatsPhone==item.calledPhone?'呼入':'呼出'}}</span>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="未接来电">
                                    <div class="paneContent" :style="{height:(th-82)+'px'}">
                                        <div v-for="(item,i) in callRecordData" :key="i" @click="activeIndex=i">
                                            <el-row type="flex" :class="{'row-bg':true,xz:activeIndex==i}" justify="space-around">
                                                <el-col :span="18">
                                                    <span :class="{'number':true,'red':false,'blue':true}">{{13625610000}}<span>（已接）</span></span><br>
                                                    <span class="address">{{item.address}}</span>
                                                </el-col>
                                                <el-col :span="6">
                                                    <div :class="{'iconPhone':true,'red':false,'blue':true}">
                                                        <i class="el-icon-phone"></i>
                                                        <span>呼入</span>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>

                            <el-pagination
                                :current-page.sync="callCurrentPage"
                                :page-size="20"
                                small
                                background
                                layout="total, prev, pager, next"
                                :total="callTotal"
                                style="padding-top:13px;border-top:1px solid #eee">
                            </el-pagination>

                        </el-card>
                    </el-col>
                    <el-col :span="17">

                        <el-card class="box-card"  shadow="never" :style="{height:(th+50)+'px'}" :body-style='{padding:"10px"}'>
                            <div slot="header" class="clearfix">
                                <div style="float: left;" class="headerInfo"><span>小李</span><br>
                                <span>13611112222</span></div>
                                <el-button type="success" style="float: right;margin:12px 20px" plain @click.native="elderlyAdd">注册</el-button>
                                <div style="clear: both;"></div>
                            </div>
                            <el-tabs type="card" :style="{height:(th-12)+'px'}">
                                <el-tab-pane label="来电详情">
                                    <div class="paneContent" :style="{height:(th-92)+'px'}">
                                        <div v-for="(item,i) in callRecordData" :key="i" @click="activeIndex=i">
                                            <el-row type="flex" :class="{'row-bg':true,xz:activeIndex==i,'red':item.recStatus==-1||item.recStatus==-2,'blue':item.recStatus==1}" justify="space-around">
                                                <el-col :span="18">
                                                    <span :class="{'number':true,}">{{seatsPhone==item.calledPhone?item.callingPhone:item.calledPhone}}<span>{{item.recStatus==-1||item.recStatus==-2 ?'（未接）':'（已接）'}}</span></span><br>
                                                    <span class="address">{{item.address}}</span>
                                                </el-col>
                                                <el-col :span="6">
                                                    <div :class="{'iconPhone':true}">
                                                        <i class="el-icon-phone"></i>
                                                        <span>{{ seatsPhone==item.calledPhone?'呼入':'呼出'}}</span>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="基本信息">
                                    <div class="paneContent" :style="{height:(th-82)+'px'}">
                                        <div v-for="(item,i) in callRecordData" :key="i" @click="activeIndex=i">
                                            <el-row type="flex" :class="{'row-bg':true,xz:activeIndex==i,'red':item.recStatus==-1||item.recStatus==-2,'blue':item.recStatus==1}" justify="space-around">
                                                <el-col :span="18">
                                                    <span :class="{'number':true,}">{{seatsPhone==item.calledPhone?item.callingPhone:item.calledPhone}}<span>{{item.recStatus==-1||item.recStatus==-2 ?'（未接）':'（已接）'}}</span></span><br>
                                                    <span class="address">{{item.address}}</span>
                                                </el-col>
                                                <el-col :span="6">
                                                    <div :class="{'iconPhone':true}">
                                                        <i class="el-icon-phone"></i>
                                                        <span>{{ seatsPhone==item.calledPhone?'呼入':'呼出'}}</span>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="订单记录">
                                    <template>
                                        <el-table :data="tableData" :height="th-172" border style="width: 100%;">
                                            <el-table-column prop="elderlyDTO.name" label="姓名" width="150"></el-table-column>
                                            <el-table-column prop="elderlyDTO.zoneName" label="所属区域" width="150"></el-table-column>
                                            <el-table-column prop="listOrderGoodsDTO[0].goodsName" label="标题" width="150"></el-table-column>
                                            <el-table-column prop="listOrderGoodsDTO[0].goodsPrice" label="销售价（元）"></el-table-column>
                                            <el-table-column prop="listOrderGoodsDTO[0].number" label="购买数量"></el-table-column>
                                            <el-table-column prop="listOrderGoodsDTO[0].planTime" :formatter="timefilter" width="200" label="预约时间"></el-table-column>
                                            <el-table-column prop="status" :formatter="statuss" label="订单状态"></el-table-column>
                                        </el-table>
                                        <div style="text-align: left;background-color: #fff;padding: 10px;">
                                            <el-pagination small
                                                @current-change="current_change"
                                                :current-page.sync="currentPage"
                                                :page-size="20"
                                                background
                                                layout="total, prev, pager, next"
                                                :total="totalItems">
                                            </el-pagination>
                                            <div style="clear: both;"></div>
                                        </div>
                                    </template>
                                </el-tab-pane>
                            </el-tabs>
                        </el-card>
                    </el-col>
                </el-row>
            </div>

        </div>



        <el-dialog
            title="老人注册"
            :visible.sync="elderlyDialog" :before-close="handleClose" top="30vh" width="700px">
            <el-row :gutter="30">
                <el-form :model="addElderlyForm" :rules="elderlyRules" ref="addElderlyForm">
                    <el-col :span="12">
                        <el-form-item label="姓名" required prop="name">
                            <el-input v-model="addElderlyForm.name" placeholder="请输入姓名" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号" required prop="phone">
                            <el-input v-model="addElderlyForm.phone" maxlength="11" placeholder="请输入手机号码" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="elderlyDialog = false">取 消</el-button>
                <el-button type="primary" @click="confirmAddEl">确 定</el-button>
            </span>
        </el-dialog>

      <Cart ref="myCart" v-show="showModalCart" v-on:closeCart="closeCart" v-on:getList="getList"></Cart>

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import Cart from "./Cart";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,

                elderlyDialog:false,
                showModalCart:false,
                showModalEdit:false,

                tableData:null,
                zoneValue:[],
                idNumber:'',
                phone:'',
                totalItems: 0,
                pageSize:20,
                imgUrl:this.$imgUrl,
                currentPage:1,
                th:0,
                name:'',

                addElderlyForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode: getStaffCode(),
                    name:'',
                    phone:'',
                },

                elderlyRules:{
                    phone:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号'
                        },
                    ],
                    name:[
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                    ]
                },

                callRecordData:[],
                callTotal:0,
                callCurrentPage:1,
                activeIndex:0,
                seatsPhone:''

            }
        },
        components:{
            Cart
        },
        created(){

            this.init();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{

            init(){
                this.getCallRecord()
            },

            getCallRecord(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"CallRecord/PageForSeats2",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.callCurrentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){

                        this.seatsPhone = response.data.data.seatsPhone;

                        this.callRecordData = response.data.data.callRecord.list;
                        this.callTotal = response.data.data.callRecord.total;

                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

            toggleModalAdd:function(){
                this.showModalCart = !this.showModalCart;
                this.$refs.myCart.init();
            },
            elderlyAdd(){
                this.elderlyDialog=true
            },

            handleClose(done){
                this.$refs.addElderlyForm.resetFields();
                done();
            },
            confirmAddEl(){
                this.$refs.addElderlyForm.validate((valid) => {
                    if(valid){
                        this.addElderlyForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                        this.$axios({
                            method: 'post',
                            url: this.$shopUrl+"Elderly/Add",
                            data: this.addElderlyForm
                        }).then(
                            (response) => {
                                if (response.data.error == 0) {
                                    this.elderlyDialog=false
                                    this.$confirm('添加成功，是否为此老人下单？', '提示', {
                                        confirmButtonText: '确定',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                        }).then(() => {
                                            this.$message({
                                                type: 'success',
                                                message: '去下单!'
                                            });
                                        }).catch(() => {});
                                }else if(response.data.error == 1){
                                    this.$message.error(response.data.message)
                                }
                            }
                        )
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },

            timefilter(row){
                return timefilters(row.listOrderGoodsDTO[0].planTime)
            },

            closeCart:function(){
                this.showModalCart = !this.showModalCart;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            statuss(row, column, cellValue){
                return this.allStatus(cellValue,['待付款','待发货','待收货','交易成功','退款中','交易关闭','交易取消','已评价',"","",'待付款','待接单','已接单','服务中','服务完成','交易取消','已评价']);
            },
            allStatus(row,status){
                for(var i in status){
                    if(i==row){
                        return status[i]
                    }
                }
                return "其它";
            },

            getList(isSearch){
                if(isSearch)this.currentPage=1

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"OrderBusiness/PageForStaffBusinessSchedule",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    //console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.pageInfoOrderBusinessDTO.list;
                        this.totalItems = response.data.data.pageInfoOrderBusinessDTO.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },


        }
    }
</script>

<style lang="scss" scoped>
    .row-bg {
        padding:10px;
        background-color: #f9fafc;
        margin-bottom: 5px;
        min-width: 360px;
        .number{
            font-size: 21px;
            margin-bottom: 15px;
        }
        .address{
            color: #999;
            margin-left: 5px;
        }
        .iconPhone{
            font-size: 18px;
            margin: 15px;
            float: right;
        }

    }
    .red{
        color: #F56C6C;
    }
    .blue{
        color:#409EFF;
    }
    .xz{
        border: 2px solid #b3d8ff;
        border-radius: 5px;
        background: #ecf5ff;
        box-sizing: border-box;
    }
    /deep/ .el-tab-pane{
        ::-webkit-scrollbar {
            width: 0px;
            height: 10px;
            // margin-left: 5px;
        }
        ::-webkit-scrollbar-thumb {
            border-radius   : 10px;
            background-color:rgb(140, 197, 255);
        }
        ::-webkit-scrollbar-track {
            box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
            background   : #ededed;
            border-radius: 10px;
        }
    }
    .paneContent{
        overflow-y: auto;
    }
    .headerInfo :nth-child(1){
        line-height: 45px;
        font-size: 25px;
    }
</style>
